// eslint-disable-next-line import/prefer-default-export
export const AUTH_MSG = {
  authorize: {
    title: "Authorize application to your Revv account?",
    subtitle: "This application will be able to:",
    usageList: [
      "Create documents on your behalf",
      "Send documents on your behalf",
      "Download signed documents",
    ],
  },
  cancel: {
    title: "🚫 &nbsp;Access denied, beacuse you canceled",
    subtitle: "This application <b>will not be</b> able to:",
    usageList: [
      "Create documents on your behalf",
      "Send documents on your behalf",
      "Download signed documents",
    ],
  },
  apiFail: {
    title: "Something went wrong, please retry",
    subtitle: "This could be because",
    usageList: ["API call failed", "Redirect error"],
  },
  accessDenied: {
    title: "🚫 &nbsp;Access denied, retry with admin credentials",
    subtitle:
      "Only the Admin for your Revv account can give authorization. Please log in using Admin credentials or contact the concerned user",
  },
};
